import {CSSProperties, FC} from 'react';


export interface IIconSettingsBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSettingsBmw: FC<IIconSettingsBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12.244 9.28a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm5.803 4.22a5.97 5.97 0 0 1-.639 1.433l1.553 1.499-2.121 2.093-1.675-1.566c-.476.281-.665.483-1.665.625V20h-3v-2.416c-.5-.142-.945-.357-1.421-.639l-1.493 1.553-2.09-2.121 1.568-1.444a5.907 5.907 0 0 1-.623-1.433H4v-3h2.441c.141-1 .357-1.176.638-1.653L5.526 7.24l2.122-2.15 1.43 1.54c.477-.28.922-.51 1.422-.652V4h3v1.978c1 .141 1.188.357 1.665.638l1.614-1.554 2.151 2.123-1.537 1.662c.281.477.512.653.654 1.653H20v3h-1.953Z" clipRule="evenodd" />
        </svg>
    );
};
